import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Income } from '../../incomes/income';
import { CaseIncomeService } from '../../cases/incomes/case-income.service';
import { CaseIncome } from '../../cases/incomes/case-income';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Component({
  selector: 'app-case-income-form-item',
  templateUrl: 'case-income-form-item.component.html',
})
export class CaseIncomeFormItemComponent implements OnInit {
  public editorOptions = {
    placeholder: 'Enter your note...',
    modules: {
      toolbar: ['bold', 'link'],
    },
  };

  @Input() public caseId: string = undefined;

  @Input() public item: Income;

  @Input() saveAllClicked: EventEmitter<boolean>;

  @Input() public size: number = 4;
  public foundItem: CaseIncome = undefined;
  public isSaved: boolean = true;
  private loading: boolean = true;

  constructor(private readonly service: CaseIncomeService) {}

  public get isLoading(): boolean {
    return this.loading;
  }

  public ngOnInit(): void {
    this.saveAllClicked.subscribe(r => this.save());
    this.loadItem();
  }

  public valueChanged(): void {
    this.isSaved = false;
  }

  public save(): void {
    this.loading = true;
    this.service
      .updateCaseIncome(this.foundItem.id, this.foundItem, {
        parameters: { id: this.caseId },
      })
      .subscribe(() => {
        this.loading = false;
        this.isSaved = true;
      });
  }

  private loadItem(): void {
    this.loading = true;
    this.service
      .findCaseIncome(this.item.id, { parameters: { id: this.caseId } })
      .subscribe(foundItem => {
        this.foundItem = foundItem;
        this.loading = false;
        this.isSaved = true;
      });
  }
}
